import { render } from "./DeletedBranches.vue?vue&type=template&id=6d4f9984&scoped=true"
import script from "./DeletedBranches.vue?vue&type=script&lang=js"
export * from "./DeletedBranches.vue?vue&type=script&lang=js"

import "./DeletedBranches.vue?vue&type=style&index=0&id=6d4f9984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4f9984"]])

export default __exports__